import { render, staticRenderFns } from "./production-task-form.vue?vue&type=template&id=7c67115d"
import script from "./production-task-form.vue?vue&type=script&lang=js"
export * from "./production-task-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports